// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .btn-container-new {
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
} */

/* .return-check-box-wrapper {
  margin-bottom: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
} */

/* .return-skipBtnContainer {
  display: flex !important;
  width: 100% !important;
  flex-direction: column;
  gap: 1rem;
} */

/* .return-order-id-input {
  padding: 1rem;
} */

/* .return-modal-heading {
  font-size: 1.2rem !important;
  font-weight: bold !important;
} */

/* .return-main-container {
  width: calc(100% - 6.2rem);
  margin-top: 1rem;
  background-color: var(--surface-white);
  border-radius: 8px;
  padding-top: 10px;
  height: 100%;
} */

.return-main-container-content-buttons {
  display: flex;
  gap: 0.5rem;
  padding: 0px 0px 10px 15px;
}

.return-value-bar {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  position: absolute;
  width: -webkit-fill-available;
  height: 5rem;
  margin: 0.5rem 2rem 1rem 0.7rem;
  align-items: center;
  box-shadow:
    rgba(0, 0, 0, 0.16) 0px 3px 6px,
    rgba(0, 0, 0, 0.23) 0px 3px 6px;
  border-radius: 5px;
  padding: 0.5rem;
}

.return-value-bar-text {
  font-size: 1rem;
  font-weight: bold;
  border: 2px solid rgb(91, 90, 90);
  padding: 0.5rem 1rem;
  border-radius: 5px;
}

.order-select-wrapper .soft-select__control {
  border: none;
  background-color: var(--surface-g0);
  border-radius: 4px;
}

.order-select-wrapper .soft-select__single-value {
  font-weight: 600;
  color: var(--surface-g5);
}

.order-select-wrapper .soft-datepicker {
  border: none;
  background-color: var(--surface-g0);
  border-radius: 4px;
  padding: 10px 12px 10px 12px !important;
}

.order-select-wrapper .react-datepicker__input-container {
  flex-direction: row-reverse;
}

.order-select-wrapper .react-datepicker__header {
  background-color: #ffffff;
  border: none;
}

.order-select-wrapper .react-datepicker__day-names {
  background-color: var(--surface-g0);
}

/* ─────────────────────────────────────────────────────────
   Existing styles — unchanged, nothing removed
   ───────────────────────────────────────────────────────── */

.btn-container-new {
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
}

.return-check-box-wrapper {
  margin-bottom: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.return-skipBtnContainer {
  display: flex !important;
  width: 100% !important;
  flex-direction: column;
  gap: 1rem;
}

.return-order-id-input {
  padding: 1rem;
}

.return-modal-heading {
  font-size: 1.2rem !important;
  font-weight: bold !important;
}

.return-main-container {
  width: calc(100% - 6.2rem);
  margin-top: 1rem;
  background-color: var(--surface-white);
  border-radius: 8px;
  padding-top: 10px;
  height: 100%;
}

.return-main-container-content-buttons {
  display: flex;
  gap: 0.5rem;
  padding: 0px 0px 10px 15px;
}

.return-value-bar {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  position: absolute;
  width: -webkit-fill-available;
  height: 5rem;
  margin: 0.5rem 2rem 1rem 0.7rem;
  align-items: center;
  box-shadow:
    rgba(0, 0, 0, 0.16) 0px 3px 6px,
    rgba(0, 0, 0, 0.23) 0px 3px 6px;
  border-radius: 5px;
  padding: 0.5rem;
}

.return-value-bar-text {
  font-size: 1rem;
  font-weight: bold;
  border: 2px solid rgb(91, 90, 90);
  padding: 0.5rem 1rem;
  border-radius: 5px;
}

.return-main-box {
  /* margin-left: 17px; */
  border-radius: 8px !important;
  width: 100%;
  padding: 10px !important;
  /* background-color: white; */
  flex: 1;
  /* height: 89%; */
  /* height: 77vh; */
  /* height: 100vh; */
  /* margin-bottom: 70px; */
}

.dark .return-main-box {
  color: #fff !important;
  background-color: #2b2f42;
}

.order-select-wrapper .soft-select__control {
  border: none;
  background-color: var(--surface-g0);
  border-radius: 4px;
}

.order-select-wrapper .soft-select__single-value {
  font-weight: 600;
  color: var(--surface-g5);
}

.order-select-wrapper .soft-datepicker {
  border: none;
  background-color: var(--surface-g0);
  border-radius: 4px;
  padding: 10px 12px 10px 12px !important;
}

.order-select-wrapper .react-datepicker__input-container {
  flex-direction: row-reverse;
}

.order-select-wrapper .react-datepicker__header {
  background-color: #ffffff;
  border: none;
}

.order-select-wrapper .react-datepicker__day-names {
  background-color: var(--surface-g0);
}

.returnScreenContainer {
  /* width: calc(100% - 7.5rem); */
  width: 100%;
  margin-bottom: 70px;
}

/* ─────────────────────────────────────────────────────────
   NEW: Returns header — pill filter + New Return button
   ───────────────────────────────────────────────────────── */

/* Outer header block */
.returns-header {
  padding: 0 0 12px 0;
}

/* Single flex row: tabs on the left, button on the right */
.returns-header__row {
  display: flex;
  align-items: center;

  gap: 1rem;
  flex-wrap: wrap;
}

.returns-header___justify-space-between {
  justify-content: space-between;
}

.returns-header___justify-end {
  justify-content: flex-end;
}

/* ── Pill tab group ───────────────────────────────────── */

/* Scrollable track — hides scrollbar but stays usable */
.returns-header__tabs-scroll {
  overflow-x: auto;
  scrollbar-width: none;
  /* Firefox */
}

.returns-header__tabs-scroll::-webkit-scrollbar {
  display: none;
  /* Chrome / Safari */
}

/* The outer pill border */
.returns-header__tabs {
  display: inline-flex;
  align-items: center;
  min-width: max-content;
  background: #ffffff;
  border: 1px solid rgba(226, 232, 240, 0.8);
  border-radius: 24px;
  padding: 6px 12px;
  gap: 6px;
  box-shadow:
    0 1px 3px rgba(0, 0, 0, 0.04),
    0 1px 2px rgba(0, 0, 0, 0.02);
}

/* Reset list inside nav */
.returns-header__tabs-inner {
  display: flex;
  align-items: center;
  gap: 6px;
  list-style: none;
  margin: 0;
  padding: 0;
}

/* Individual pill buttons */
.returns-header__tab {
  border: none;
  background: transparent;
  border-radius: 16px;
  padding: 8px 16px;
  font-size: 13px;
  font-weight: 500;
  color: #475569;
  cursor: pointer;
  white-space: nowrap;
  line-height: 1;
  transition:
    background 0.15s ease,
    color 0.15s ease;
}

.returns-header__tab:hover {
  background: #f1f5f9;
  color: #0f172a;
}

/* Active / selected state */
.returns-header__tab--active {
  background: #2a71ff;
  color: #ffffff;
  box-shadow: 0 4px 14px rgba(42, 113, 255, 0.22);
}

/* ── New Return button ────────────────────────────────── */

.returns-header__new-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: #2a71ff;
  color: #ffffff;
  border: none;
  border-radius: 22px;
  padding: 0 20px;
  height: 44px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
  box-shadow: 0 14px 30px rgba(42, 113, 255, 0.24);
  transition:
    background 0.15s ease,
    transform 0.1s ease;
}

.returns-header__new-btn:hover {
  background: #1f63ea;
}

.returns-header__new-btn:active {
  transform: scale(0.98);
}

/* The SVG icon inside the button */
.returns-header__new-btn-icon {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}

/* ── Table wrapper ────────────────────────────────────── */

/* Wraps CustomerPaginatedTable — ensures it fills available height */
.returns-table-wrapper {
  height: 100%;
  width: 100%;
  overflow: hidden;
}

/* ── Cell styles for RETURNS_COLUMNS ─────────────────── */

/* Date cell */
.returns-cell__date {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.returns-cell__date-primary {
  font-size: 11px;
  font-weight: 600;
  color: #0f172a;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.returns-cell__date-secondary {
  font-size: 9px;
  color: #64748b;
}

/* Order ID / Return ID */
.returns-cell__id {
  display: block;
  font-family: monospace;
  font-size: 10px;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.returns-cell__id--order {
  color: #334155;
}

.returns-cell__id--return {
  color: #2a71ff;
}

/* Customer */
.returns-cell__customer {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.returns-cell__customer-name {
  font-size: 11px;
  font-weight: 600;
  color: #0f172a;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.returns-cell__customer-phone {
  font-size: 9px;
  color: #64748b;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Cashier */
.returns-cell__cashier {
  font-size: 10px;
  font-weight: 500;
  color: #334155;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Amount */
.returns-cell__amount {
  font-size: 11px;
  font-weight: 700;
  color: #0f172a;
}

/* Payment mode pill */
.returns-cell__mode-pill {
  display: inline-flex;
  align-items: center;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  border-radius: 9999px;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  padding: 2px 6px;
  font-size: 9px;
  font-weight: 600;
  color: #475569;
}

/* Status badge */
.returns-cell__status-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 0;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  border-radius: 9999px;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  padding: 2px 6px;
  font-size: 8px;
  font-weight: 600;
  text-transform: uppercase;
  color: #475569;
}

/* Refunded variant */
.returns-cell__status-badge--refunded {
  border-color: #fecdd3;
  background: #fff1f2;
  color: #be123c;
}

/* ════════════════════════════════════════════════════
   DARK THEME — Returns
   ════════════════════════════════════════════════════ */
.dark .return-main-container {
  background-color: #0f172a;
}
.dark .returns-header__tabs {
  background: #1e293b;
  border-color: rgba(51, 65, 85, 0.8);
  box-shadow: none;
}
.dark .returns-header__tab {
  color: #94a3b8;
}
.dark .returns-header__tab:hover {
  background: #334155;
  color: #e2e8f0;
}
.dark .returns-header__tab--active {
  background: #2a71ff;
  color: #fff;
}
/* Cell text */
.dark .returns-cell__date-primary {
  color: #e2e8f0;
}
.dark .returns-cell__date-secondary {
  color: #64748b;
}
.dark .returns-cell__id--order {
  color: #94a3b8;
}
.dark .returns-cell__id--return {
  color: #60a5fa;
}
.dark .returns-cell__customer-name {
  color: #e2e8f0;
}
.dark .returns-cell__customer-phone {
  color: #64748b;
}
.dark .returns-cell__cashier {
  color: #94a3b8;
}
.dark .returns-cell__amount {
  color: #f1f5f9;
}
.dark .returns-cell__mode-pill {
  background: #1e293b;
  border-color: #334155;
  color: #94a3b8;
}
.dark .returns-cell__status-badge {
  background: #1e293b;
  border-color: #334155;
  color: #94a3b8;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/Returns/Returns.css"],"names":[],"mappings":"AAAA;;;;GAIG;;AAEH;;;;;GAKG;;AAEH;;;;;GAKG;;AAEH;;GAEG;;AAEH;;;GAGG;;AAEH;;;;;;;GAOG;;AAEH;EACE,aAAa;EACb,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,YAAY;EACZ,+BAA+B;EAC/B,mBAAmB;EACnB;;mCAEiC;EACjC,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,iCAAiC;EACjC,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mCAAmC;EACnC,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,mCAAmC;AACrC;;AAEA;;8DAE8D;;AAE9D;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,sBAAsB;EACtB,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,sCAAsC;EACtC,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,YAAY;EACZ,+BAA+B;EAC/B,mBAAmB;EACnB;;mCAEiC;EACjC,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,iCAAiC;EACjC,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,WAAW;EACX,wBAAwB;EACxB,6BAA6B;EAC7B,OAAO;EACP,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mCAAmC;EACnC,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,gCAAgC;EAChC,WAAW;EACX,mBAAmB;AACrB;;AAEA;;8DAE8D;;AAE9D,uBAAuB;AACvB;EACE,mBAAmB;AACrB;;AAEA,2DAA2D;AAC3D;EACE,aAAa;EACb,mBAAmB;;EAEnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,4DAA4D;;AAE5D,wDAAwD;AACxD;EACE,gBAAgB;EAChB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA,0BAA0B;AAC1B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,0CAA0C;EAC1C,mBAAmB;EACnB,iBAAiB;EACjB,QAAQ;EACR;;iCAE+B;AACjC;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA,4BAA4B;AAC5B;EACE,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd;;oBAEkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;EACE,mBAAmB;EACnB,cAAc;EACd,+CAA+C;AACjD;;AAEA,4DAA4D;;AAE5D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,gDAAgD;EAChD;;uBAEqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,mCAAmC;AACnC;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA,4DAA4D;;AAE5D,qEAAqE;AACrE;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;AAClB;;AAEA,2DAA2D;;AAE3D,cAAc;AACd;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,cAAc;EACd,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,aAAa;AACb;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,YAAY;AACZ;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,WAAW;AACX;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;yDAEyD;AACzD;EACE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,mCAAmC;EACnC,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA,cAAc;AACd;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB","sourcesContent":["/* .btn-container-new {\n  display: flex;\n  gap: 1rem;\n  justify-content: flex-end;\n} */\n\n/* .return-check-box-wrapper {\n  margin-bottom: 1rem;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n} */\n\n/* .return-skipBtnContainer {\n  display: flex !important;\n  width: 100% !important;\n  flex-direction: column;\n  gap: 1rem;\n} */\n\n/* .return-order-id-input {\n  padding: 1rem;\n} */\n\n/* .return-modal-heading {\n  font-size: 1.2rem !important;\n  font-weight: bold !important;\n} */\n\n/* .return-main-container {\n  width: calc(100% - 6.2rem);\n  margin-top: 1rem;\n  background-color: var(--surface-white);\n  border-radius: 8px;\n  padding-top: 10px;\n  height: 100%;\n} */\n\n.return-main-container-content-buttons {\n  display: flex;\n  gap: 0.5rem;\n  padding: 0px 0px 10px 15px;\n}\n\n.return-value-bar {\n  display: flex;\n  justify-content: flex-end;\n  gap: 1rem;\n  position: absolute;\n  width: -webkit-fill-available;\n  height: 5rem;\n  margin: 0.5rem 2rem 1rem 0.7rem;\n  align-items: center;\n  box-shadow:\n    rgba(0, 0, 0, 0.16) 0px 3px 6px,\n    rgba(0, 0, 0, 0.23) 0px 3px 6px;\n  border-radius: 5px;\n  padding: 0.5rem;\n}\n\n.return-value-bar-text {\n  font-size: 1rem;\n  font-weight: bold;\n  border: 2px solid rgb(91, 90, 90);\n  padding: 0.5rem 1rem;\n  border-radius: 5px;\n}\n\n.order-select-wrapper .soft-select__control {\n  border: none;\n  background-color: var(--surface-g0);\n  border-radius: 4px;\n}\n\n.order-select-wrapper .soft-select__single-value {\n  font-weight: 600;\n  color: var(--surface-g5);\n}\n\n.order-select-wrapper .soft-datepicker {\n  border: none;\n  background-color: var(--surface-g0);\n  border-radius: 4px;\n  padding: 10px 12px 10px 12px !important;\n}\n\n.order-select-wrapper .react-datepicker__input-container {\n  flex-direction: row-reverse;\n}\n\n.order-select-wrapper .react-datepicker__header {\n  background-color: #ffffff;\n  border: none;\n}\n\n.order-select-wrapper .react-datepicker__day-names {\n  background-color: var(--surface-g0);\n}\n\n/* ─────────────────────────────────────────────────────────\n   Existing styles — unchanged, nothing removed\n   ───────────────────────────────────────────────────────── */\n\n.btn-container-new {\n  display: flex;\n  gap: 1rem;\n  justify-content: flex-end;\n}\n\n.return-check-box-wrapper {\n  margin-bottom: 1rem;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.return-skipBtnContainer {\n  display: flex !important;\n  width: 100% !important;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.return-order-id-input {\n  padding: 1rem;\n}\n\n.return-modal-heading {\n  font-size: 1.2rem !important;\n  font-weight: bold !important;\n}\n\n.return-main-container {\n  width: calc(100% - 6.2rem);\n  margin-top: 1rem;\n  background-color: var(--surface-white);\n  border-radius: 8px;\n  padding-top: 10px;\n  height: 100%;\n}\n\n.return-main-container-content-buttons {\n  display: flex;\n  gap: 0.5rem;\n  padding: 0px 0px 10px 15px;\n}\n\n.return-value-bar {\n  display: flex;\n  justify-content: flex-end;\n  gap: 1rem;\n  position: absolute;\n  width: -webkit-fill-available;\n  height: 5rem;\n  margin: 0.5rem 2rem 1rem 0.7rem;\n  align-items: center;\n  box-shadow:\n    rgba(0, 0, 0, 0.16) 0px 3px 6px,\n    rgba(0, 0, 0, 0.23) 0px 3px 6px;\n  border-radius: 5px;\n  padding: 0.5rem;\n}\n\n.return-value-bar-text {\n  font-size: 1rem;\n  font-weight: bold;\n  border: 2px solid rgb(91, 90, 90);\n  padding: 0.5rem 1rem;\n  border-radius: 5px;\n}\n\n.return-main-box {\n  /* margin-left: 17px; */\n  border-radius: 8px !important;\n  width: 100%;\n  padding: 10px !important;\n  /* background-color: white; */\n  flex: 1;\n  /* height: 89%; */\n  /* height: 77vh; */\n  /* height: 100vh; */\n  /* margin-bottom: 70px; */\n}\n\n.dark .return-main-box {\n  color: #fff !important;\n  background-color: #2b2f42;\n}\n\n.order-select-wrapper .soft-select__control {\n  border: none;\n  background-color: var(--surface-g0);\n  border-radius: 4px;\n}\n\n.order-select-wrapper .soft-select__single-value {\n  font-weight: 600;\n  color: var(--surface-g5);\n}\n\n.order-select-wrapper .soft-datepicker {\n  border: none;\n  background-color: var(--surface-g0);\n  border-radius: 4px;\n  padding: 10px 12px 10px 12px !important;\n}\n\n.order-select-wrapper .react-datepicker__input-container {\n  flex-direction: row-reverse;\n}\n\n.order-select-wrapper .react-datepicker__header {\n  background-color: #ffffff;\n  border: none;\n}\n\n.order-select-wrapper .react-datepicker__day-names {\n  background-color: var(--surface-g0);\n}\n\n.returnScreenContainer {\n  /* width: calc(100% - 7.5rem); */\n  width: 100%;\n  margin-bottom: 70px;\n}\n\n/* ─────────────────────────────────────────────────────────\n   NEW: Returns header — pill filter + New Return button\n   ───────────────────────────────────────────────────────── */\n\n/* Outer header block */\n.returns-header {\n  padding: 0 0 12px 0;\n}\n\n/* Single flex row: tabs on the left, button on the right */\n.returns-header__row {\n  display: flex;\n  align-items: center;\n\n  gap: 1rem;\n  flex-wrap: wrap;\n}\n\n.returns-header___justify-space-between {\n  justify-content: space-between;\n}\n\n.returns-header___justify-end {\n  justify-content: flex-end;\n}\n\n/* ── Pill tab group ───────────────────────────────────── */\n\n/* Scrollable track — hides scrollbar but stays usable */\n.returns-header__tabs-scroll {\n  overflow-x: auto;\n  scrollbar-width: none;\n  /* Firefox */\n}\n\n.returns-header__tabs-scroll::-webkit-scrollbar {\n  display: none;\n  /* Chrome / Safari */\n}\n\n/* The outer pill border */\n.returns-header__tabs {\n  display: inline-flex;\n  align-items: center;\n  min-width: max-content;\n  background: #ffffff;\n  border: 1px solid rgba(226, 232, 240, 0.8);\n  border-radius: 24px;\n  padding: 6px 12px;\n  gap: 6px;\n  box-shadow:\n    0 1px 3px rgba(0, 0, 0, 0.04),\n    0 1px 2px rgba(0, 0, 0, 0.02);\n}\n\n/* Reset list inside nav */\n.returns-header__tabs-inner {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n/* Individual pill buttons */\n.returns-header__tab {\n  border: none;\n  background: transparent;\n  border-radius: 16px;\n  padding: 8px 16px;\n  font-size: 13px;\n  font-weight: 500;\n  color: #475569;\n  cursor: pointer;\n  white-space: nowrap;\n  line-height: 1;\n  transition:\n    background 0.15s ease,\n    color 0.15s ease;\n}\n\n.returns-header__tab:hover {\n  background: #f1f5f9;\n  color: #0f172a;\n}\n\n/* Active / selected state */\n.returns-header__tab--active {\n  background: #2a71ff;\n  color: #ffffff;\n  box-shadow: 0 4px 14px rgba(42, 113, 255, 0.22);\n}\n\n/* ── New Return button ────────────────────────────────── */\n\n.returns-header__new-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  background: #2a71ff;\n  color: #ffffff;\n  border: none;\n  border-radius: 22px;\n  padding: 0 20px;\n  height: 44px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  white-space: nowrap;\n  flex-shrink: 0;\n  box-shadow: 0 14px 30px rgba(42, 113, 255, 0.24);\n  transition:\n    background 0.15s ease,\n    transform 0.1s ease;\n}\n\n.returns-header__new-btn:hover {\n  background: #1f63ea;\n}\n\n.returns-header__new-btn:active {\n  transform: scale(0.98);\n}\n\n/* The SVG icon inside the button */\n.returns-header__new-btn-icon {\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n}\n\n/* ── Table wrapper ────────────────────────────────────── */\n\n/* Wraps CustomerPaginatedTable — ensures it fills available height */\n.returns-table-wrapper {\n  height: 100%;\n  width: 100%;\n  overflow: hidden;\n}\n\n/* ── Cell styles for RETURNS_COLUMNS ─────────────────── */\n\n/* Date cell */\n.returns-cell__date {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.returns-cell__date-primary {\n  font-size: 11px;\n  font-weight: 600;\n  color: #0f172a;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.returns-cell__date-secondary {\n  font-size: 9px;\n  color: #64748b;\n}\n\n/* Order ID / Return ID */\n.returns-cell__id {\n  display: block;\n  font-family: monospace;\n  font-size: 10px;\n  font-weight: 500;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.returns-cell__id--order {\n  color: #334155;\n}\n\n.returns-cell__id--return {\n  color: #2a71ff;\n}\n\n/* Customer */\n.returns-cell__customer {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.returns-cell__customer-name {\n  font-size: 11px;\n  font-weight: 600;\n  color: #0f172a;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.returns-cell__customer-phone {\n  font-size: 9px;\n  color: #64748b;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* Cashier */\n.returns-cell__cashier {\n  font-size: 10px;\n  font-weight: 500;\n  color: #334155;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* Amount */\n.returns-cell__amount {\n  font-size: 11px;\n  font-weight: 700;\n  color: #0f172a;\n}\n\n/* Payment mode pill */\n.returns-cell__mode-pill {\n  display: inline-flex;\n  align-items: center;\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  border-radius: 9999px;\n  border: 1px solid #e2e8f0;\n  background: #f8fafc;\n  padding: 2px 6px;\n  font-size: 9px;\n  font-weight: 600;\n  color: #475569;\n}\n\n/* Status badge */\n.returns-cell__status-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 0;\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  border-radius: 9999px;\n  border: 1px solid #e2e8f0;\n  background: #f8fafc;\n  padding: 2px 6px;\n  font-size: 8px;\n  font-weight: 600;\n  text-transform: uppercase;\n  color: #475569;\n}\n\n/* Refunded variant */\n.returns-cell__status-badge--refunded {\n  border-color: #fecdd3;\n  background: #fff1f2;\n  color: #be123c;\n}\n\n/* ════════════════════════════════════════════════════\n   DARK THEME — Returns\n   ════════════════════════════════════════════════════ */\n.dark .return-main-container {\n  background-color: #0f172a;\n}\n.dark .returns-header__tabs {\n  background: #1e293b;\n  border-color: rgba(51, 65, 85, 0.8);\n  box-shadow: none;\n}\n.dark .returns-header__tab {\n  color: #94a3b8;\n}\n.dark .returns-header__tab:hover {\n  background: #334155;\n  color: #e2e8f0;\n}\n.dark .returns-header__tab--active {\n  background: #2a71ff;\n  color: #fff;\n}\n/* Cell text */\n.dark .returns-cell__date-primary {\n  color: #e2e8f0;\n}\n.dark .returns-cell__date-secondary {\n  color: #64748b;\n}\n.dark .returns-cell__id--order {\n  color: #94a3b8;\n}\n.dark .returns-cell__id--return {\n  color: #60a5fa;\n}\n.dark .returns-cell__customer-name {\n  color: #e2e8f0;\n}\n.dark .returns-cell__customer-phone {\n  color: #64748b;\n}\n.dark .returns-cell__cashier {\n  color: #94a3b8;\n}\n.dark .returns-cell__amount {\n  color: #f1f5f9;\n}\n.dark .returns-cell__mode-pill {\n  background: #1e293b;\n  border-color: #334155;\n  color: #94a3b8;\n}\n.dark .returns-cell__status-badge {\n  background: #1e293b;\n  border-color: #334155;\n  color: #94a3b8;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
